'use strict';

angular.module('shiftTraderApp')
  .controller('SandboxCtrl', function ($scope, Session, ShepherdTourService, $location, $uibModal,
                                       Organizations, $rootScope, $state, EventTrackingService, Angularytics) {
    $scope.me = Session.me;
    // loggedIn var describes whether there is a logged-in user currently using the site
    $scope.loggedIn = Session.isLoggedIn();
    var sandboxData;

    var setSandboxOpenState = function(mode) {
      if (mode) {
        $('#sandbox_bar').addClass('show');
        $scope.$emit('saTopBar:stateChangeNotification', {
          panelName: 'sandbox',
          isOpen: true
        });

      } else {
        $('#sandbox_bar').removeClass('show');
        $scope.$emit('saTopBar:stateChangeNotification', {
          panelName: 'sandbox',
          isOpen: false
        });
      }
    };

    $scope.$on('updatedSessionMe', function(event, isLoggedIn) {
      if (isLoggedIn) {
        $scope.me = Session.me;
      } else {
        setSandboxOpenState(false);
      }
    });

    $scope.$on('loginStateChanged', function(event, data) {
      $scope.loggedIn = data.state;
    });



    var mappings = [
      {
        name: 'startMwpTour',
        test: function(path) {
          return /manageWorkPeriods/.test(path);
        },
        exec: function() {
          console.log(sandboxData);
          $state.go('manageWorkPeriods.date', {date: sandboxData.info.work_period_start_date });
          ShepherdTourService.startMwpTour();
        }
      }
      // {
      //   name: 'startOrgProfileTour',
      //   test: function(path) {
      //     return /organizationProfile\/[0-9]{1,7}$/.test(path);
      //   },
      //   exec: function() {
      //     ShepherdTourService.startOrgProfileTour();
      //   }
      // }
    ];

    $scope.state = {
      showTour: false,
      showAlternateTour: false
    };

    var setShowTour = function() {
      $scope.state.showTour = _.any(mappings, function(obj) {
        return obj.test($location.path())
      });

      $scope.state.showAlternateTour = /manageWorkPeriods/.test($location.path());
    };

    setShowTour();

    $rootScope.$on('$locationChangeSuccess', function(event, data) {
      //console.log('got location change');
      setShowTour();
    });

    $scope.startTour = function() {
      // map current URL to tour that should be started
      var currentPath = $location.path();

      _.each(mappings, function(obj) {
        if (obj.test(currentPath)) {
          obj.exec();
          EventTrackingService.addEvent('tourStart', {
            _v: 1,
            _d: {
              name: obj.name,
              path: currentPath
            }
          });
          return false;
        }
      });
    };

    $scope.startAlternateTour = function() {
      ShepherdTourService.startMwpFasterTour();
      EventTrackingService.addEvent('tourStart', {
        _v: 1,
        _d: {
          name: 'mwpFasterTour',
          path: $location.path()
        }
      });
    };

    $scope.openSandboxExplained = function() {
      $uibModal.open({
        templateUrl: 'views/sandboxExplained.html',
        size: 'wide',
        controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
          $scope.close = function() {
            $uibModalInstance.dismiss('close');
          };
        }]
      });
    };

    $scope.openEmptySandboxConfirmModal = function() {
      $uibModal.open({
        templateUrl: 'views/sandboxEmptyModal.html',
        size: 'wide',
        controller: ['$scope', '$uibModalInstance', 'Session', 'Organizations', 'EventTrackingService', '$location', '$interval', 'validCouponCodes',
          function($scope, $uibModalInstance, Session, Organizations, EventTrackingService, $location, $interval, validCouponCodes) {
          $scope.close = function() {
            $uibModalInstance.dismiss('close');
          };

          var messages = [
            'Looking through demo records...',
            'Clearing demo data...',
            'Just one more second...',
            'About to bring you to the wizard...'
          ];

          $scope.state = {
            emptyingStarted: false,
            currMessageIdx: 1,
            sandboxEmptyMessage: messages[0],
            extendedTrialCode: ''
          };

          $scope.checkExtendedCouponCodeValidity = function() {
            $scope.state.trialCodeIsValid = lodash.includes(validCouponCodes, $scope.state.extendedTrialCode.toUpperCase())
          };

          $scope.startTrial = function() {
            var planId = 'SA-PLUS-L6-MONTHLY';
            var couponCode = $scope.state.extendedTrialCode || '';

            if (Session.getCurrentOrgId()) {

              Organizations.startTrial(Session.getCurrentOrgId(), planId, couponCode.toLowerCase());
              EventTrackingService.addEvent('startTrial', {
                _v: 1,
                _d: {
                  userId: Session.getCurrentUserId(),
                  path: $location.path(),
                  planId: planId
                }
              });

              Angularytics.trackEvent('GettingStarted', 'start-trial', Session.getCurrentOrgId(), Session.getCurrentOrgId());

              var interval = $interval(function() {
                if ($scope.state.currMessageIdx === (messages.length)) {
                  $interval.cancel(interval);
                } else {
                  $scope.state.sandboxEmptyMessage = messages[$scope.state.currMessageIdx];
                  $scope.state.currMessageIdx += 1;
                }

              }, 2000);

              $scope.state.emptyingStarted = true;

            }
          };
        }]
      });
    };

  });
